import FINDMONEY_EXT_1 from "./FINDMONEY_EXT_1";
export default {
  FINDMONEY_EXT_1,
};
